
import 'pages/images/image-select.tag'
import 'pages/products/products/products-list-select-modal.tag'
import 'pages/news/news-list-select-modal.tag'
riot.tag2('section-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#sections"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;news&quot;, &quot;0100&quot;) : checkPermission(&quot;news&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Добавление содержания\' : item.name || \'Редактирование содержания\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <div class="well well-sm">\n              <image-select name="picture" alt="0" size="256" section="sections" value="{item.picture}"></image-select>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-10">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Заголовок</label>\n                <input class="form-control" name="name" type="text" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row" if="{item.type == \'url\'}">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">URL</label>\n                <input class="form-control" name="url" type="text" value="{item.url}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Тип элемента</label>\n                <select class="form-control" name="type" onchange="{menuSelect}" value="{item.type}">\n                  <option each="{type, index in itemTypes}" value="{type.code}" __selected="{type.code == item.type}" no-reorder>{type.value}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idPrice\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите товар</label>\n                <div class="input-group">\n                  <input class="form-control" name="priceName" value="{item.priceName}" data-value="{item.idPrice}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectProducts}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idGroup\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите категорию товаров</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameGroup" value="{item.nameGroup}" data-value="{item.idGroup}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectGroup}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idBrand\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите бренд товаров</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameBrand" value="{item.nameBrand}" data-value="{item.idBrand}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectBrand}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idNew\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите новость</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameNews" value="{item.nameNews}" data-value="{item.idNew}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectNews}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Текст примечания</label>\n            <ckeditor name="note" value="{item.note}"></ckeditor>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Подробный текст</label>\n            <ckeditor name="text" value="{item.text}"></ckeditor>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input type="checkbox" name="enabled" __checked="{item.enabled}">Отображать на сайте\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.isNew = false;

self.item = {};
self.orders = [];

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.rules = {
    name: 'empty'
};

self.itemTypes = [{ code: 'idPrice', value: 'Товар' }, { code: 'idGroup', value: 'Категория товара' }, { code: 'idBrand', value: 'Бренд' }, { code: 'idNew', value: 'Новость' }, { code: 'url', value: 'Ссылка' }];

self.itemsHandlers = {
    selectProducts: function selectProducts() {
        modals.create('products-list-select-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {
                var _this = this;
                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
                self.item.items = self.item.items || [];

                if (items.length == 1) {
                    self.item.idPrice = items[0].id;
                    self.item.priceName = items[0].name;
                    self.update();
                }
                this.modalHide();
                _this.modalHide();
            }
        });
    },
    selectGroup: function selectGroup() {
        modals.create('group-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
                self.item.idGroup = items[0].id;
                self.item.nameGroup = items[0].name;

                self.update();
                this.modalHide();
            }
        });
    },
    selectBrand: function selectBrand() {
        modals.create('brands-list-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags.catalog.tags.datatable.getSelectedRows();
                self.item.idBrand = items[0].id;
                self.item.nameBrand = items[0].name;
                self.update();
                this.modalHide();
            }
        });
    },
    selectNews: function selectNews() {
        modals.create('news-list-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags.catalog.tags.datatable.getSelectedRows();
                self.item.idNew = items[0].id;
                self.item.nameNews = items[0].title;
                self.update();
                this.modalHide();
            }
        });
    }
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.submit = function (e) {
    var params = self.item;

    self.error = self.validation.validate(self.item, self.rules);

    if (!self.error) {
        API.request({
            object: 'SectionItem',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
                self.item = response;
                self.update();
                if (self.isNew) riot.route('/sections/' + self.item.id);
                observable.trigger('section-reload');
            }
        });
    }
};

self.menuSelect = function (e) {
    var type = self.item.type = e.target.value;
    if (type != 'idPrice') {
        self.item.priceName = null;
    }
    self.itemTypes.forEach(function (elem) {
        if (elem.code != 'url') {
            if (elem.code != type) {
                self.item[elem.code] = null;
            }
        }
    });
};

observable.on('section-new', function (id) {
    self.error = false;
    self.isNew = true;
    self.item = {
        idSection: id,
        type: 'url'
    };
    self.update();
});

observable.on('section-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.isNew = false;
    self.loader = true;
    self.item = {};

    API.request({
        object: 'SectionItem',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            if (!self.item.type) self.item.type = 'url';
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

self.on('update', function () {
    localStorage.setItem('SE_section', 'sections');
});
self.reload = function () {
    self.item.id ? observable.trigger('section-edit', self.item.id) : observable.trigger('section-new');
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/sections/section-edit.tag